import { isSameDay } from "date-fns"
import { useActiveDistributionOptions } from "hooks/firestore/advanced/useActiveDistributionOptions"
import { useOrderMode } from "hooks/misc/useOrderMode"
import ZonedOpeningHours from "utils/ZonedOpeningHours"

export function useShopStatus() {
  const { documents: distributionOptions, loading } = useActiveDistributionOptions(true)
  const orderMode = useOrderMode()
  const isSelfOrder = orderMode === "selfOrder"

  const orderableDistOptions = distributionOptions?.filter(dO => {
    const nextChange = new ZonedOpeningHours(dO.times).getNextChange()
    return (
      new ZonedOpeningHours(dO.times).getState() ||
      (dO.allowPreorder && nextChange && isSameDay(new Date(), nextChange))
    )
  })

  const orderableDistributionOptionsWithoutSelfOrder = orderableDistOptions?.filter(dO => dO.type !== "selfOrder")
  const orderableSelfOrderDistributionOptions = orderableDistOptions?.filter(dO => dO.type === "selfOrder")

  const shopIsOpen = !!orderableDistributionOptionsWithoutSelfOrder?.length
  const selfOrderPossible = !!orderableSelfOrderDistributionOptions?.length
  const allowLowOrder = true
  const minOrderValue = 0

  const deliveryOffered = !!orderableDistributionOptionsWithoutSelfOrder?.find(e => e.type === "delivery")
  const pickupOffered = !!orderableDistributionOptionsWithoutSelfOrder?.find(e => e.type === "pickup")

  const deliveryActive = !!distributionOptions?.find(e => e.type === "delivery")
  const pickupActive = !!distributionOptions?.find(e => e.type === "pickup")

  const orderingPossible = true
  const orderingActive = true

  const checkoutActive = isSelfOrder ? selfOrderPossible : shopIsOpen

  const shopClosedReason = !shopIsOpen ? (!distributionOptions?.length ? "manual" : "out_of_opening_times") : undefined

  return {
    loading,
    allowLowOrder,
    deliveryOffered,
    minOrderValue,
    pickupOffered,
    shopIsOpen,
    orderingPossible,
    orderingActive,
    checkoutActive,
    deliveryActive,
    pickupActive,
    selfOrderPossible,
    shopClosedReason,
  }
}
